<template lang="">
  <div id="wrap">
    <section id="subVisual" class="subVis2">
      <div>
        <h2>CUBEONE</h2>
        <p>
          온크루소프트는 축적된 노하우와 기술력으로, 최적의 솔루션과 서비스를
          제공하겠습니다.
        </p>
      </div>
    </section>

    <main id="cont" class="product_cubeone">
      <div class="subCon coCon">
        <section class="cubeone0">
          <p class="engtit">
            100% of our customers have
            <strong>successfully experienced</strong> in
            <strong>establishing encryption</strong>.<br class="br" />
            <strong>DB encryption conclusion, CubeOne</strong>
          </p>
          <section class="con1 clearfix inner_box">
            <h4 class="con_subtit">
              대용량 <em>DB전문 컬럼 암호화 솔루션</em>
            </h4>
            <div class="img" style="display: flex">
              <v-img
                src="@/assets/img/product/cubeone/cubeone_logo.png"
                alt=""
                style="margin: 0 auto; max-width: 35%; align-items: center"
              />
            </div>
            <div class="txt">
              <big
                >CubeOne™은 중요정보(개인정보)가 저장된 <br />
                <strong>대용량 DB에 적용</strong>하기에 알맞은
                <strong>매우 독창적인 <br />구조 </strong>를 가지고 있습니다.
              </big>
              <p>
                이러한 기술은 NEP(우수신제품인증) 및 국내외 특허로 그 독창성과
                기술력이 입증된 바 있습니다. <br />또한 많은 SKT,
                건강보험심사평가원 등의 대형 시스템 구축사업에서 비교할 수 없는
                <br />우수성이 입증 되고 있으며, CubeOne™으로 운영중인 고객들은
                매우 만족스러워 하고 있습니다.
              </p>
            </div>
          </section>
          <section class="con2">
            <h4 class="con_subtit">
              데이터와 키가 함께 유출되지 않는 <em>완벽한 키 기밀성</em>
            </h4>
            <p>
              CubeOne™은 FIPS-140 기준을 만족하며 국정원 암호모듈검증필 암호모듈
              (KLIB V.2.x)이 탑재된 안전한 제품입니다.&nbsp;<br />DB 또는
              AP서버내의 디스크에 평문으로 된 키를 저장하지 않아 어떠한 경우에도
              데이터와 키가 함께 유출될 가능성이 없는 매우 안전한 키 <br />관리
              체계를 가지고 있습니다. (지원 알고리즘: ARIA, AES, SEED, TDES,
              DES, SHA)
            </p>

            <v-sheet
              elevation="0"
              color="transparent"
              max-width="1600 "
              class="mx-auto my-10 landing-warpper text-center"
              rounded
            >
              <v-row no-gutters align="stretch">
                <v-col cols="12" md="4">
                  <v-card
                    elevation="0"
                    height="100%"
                    class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                  >
                    <div>
                      <v-img
                        src="@/assets/img/product/cubeone/cubeone_icon0-1.png"
                        alt=""
                        style="
                          margin: 0 auto;
                          max-width: 20%;
                          align-items: center;
                        "
                      />
                      <dl>
                        <dt>중요 개인정보의 저장시 암호화</dt>
                        <dd>컬럼 단위 암호화 기능</dd>
                      </dl>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card
                    elevation="0"
                    height="100%"
                    class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                  >
                    <div>
                      <v-img
                        src="@/assets/img/product/cubeone/cubeone_icon0-2.png"
                        alt=""
                        style="
                          margin: 0 auto;
                          max-width: 20%;
                          align-items: center;
                        "
                      />
                      <dl>
                        <dt>
                          중요 개인정보에 대한 접근 기록은
                          <br />별도저장장치에 저장
                        </dt>
                        <dd>
                          CubeOne™ Secure Server에 저장 <br />(DB와 분리된
                          별도의 서버에 저장)
                        </dd>
                      </dl>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card
                    elevation="0"
                    height="100%"
                    class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                  >
                    <div>
                      <v-img
                        src="@/assets/img/product/cubeone/cubeone_icon0-3.png"
                        alt=""
                        style="
                          margin: 0 auto;
                          max-width: 20%;
                          align-items: center;
                        "
                      />
                      <dl>
                        <dt>
                          중요 개인정보에 대한 접근기록은 <br />위.변조 및
                          훼손을 방지하도록 저장
                        </dt>
                        <dd>
                          암호화하여 저장 <br />(암호화는 위.변조가 불가능)
                        </dd>
                      </dl>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
              <v-row no-gutters align="stretch">
                <v-col cols="12" md="6">
                  <v-card
                    elevation="0"
                    height="100%"
                    class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                    ><div>
                      <v-img
                        src="@/assets/img/product/cubeone/cubeone_icon0-4.png"
                        alt=""
                        style="
                          margin: 0 auto;
                          max-width: 12%;
                          align-items: center;
                        "
                      />
                      <dl>
                        <dt>접근통제 실시</dt>
                        <dd>
                          암호화한 칼럼에 대한 접근제어 및 통제 <br />(네트웍
                          보안 장치와 더불어 요건 충족)
                        </dd>
                      </dl>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="12" md="6">
                  <v-card
                    elevation="0"
                    height="100%"
                    class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                    ><div>
                      <v-img
                        src="@/assets/img/product/cubeone/cubeone_icon0-5.png"
                        alt=""
                        style="
                          margin: 0 auto;
                          max-width: 12%;
                          align-items: center;
                        "
                      />
                      <dl>
                        <dt>
                          비밀번호 및 바이오정보는 <br />일방향으로 암호화하여
                          저장
                        </dt>
                        <dd>SHA-1/256/384/512 알고리즘 적용</dd>
                      </dl>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-sheet>

            <!-- <ul class="inner_box">
              <li>
                <v-img
                  src="@/assets/img/product/cubeone/cubeone_icon0-1.png"
                  alt=""
                  style="margin: 0 auto; max-width: 20%; align-items: center"
                />
                <dl>
                  <dt>중요 개인정보의 저장시 암호화</dt>
                  <dd>컬럼 단위 암호화 기능</dd>
                </dl>
              </li>
              <li>
                <v-img
                  src="@/assets/img/product/cubeone/cubeone_icon0-2.png"
                  alt=""
                  style="margin: 0 auto; max-width: 20%; align-items: center"
                />
                <dl>
                  <dt>
                    중요 개인정보에 대한 접근 기록은 <br />별도저장장치에 저장
                  </dt>
                  <dd>
                    CubeOne™ Secure Server에 저장 <br />(DB와 분리된 별도의
                    서버에 저장)
                  </dd>
                </dl>
              </li>
              <li>
                <v-img
                  src="@/assets/img/product/cubeone/cubeone_icon0-3.png"
                  alt=""
                  style="margin: 0 auto; max-width: 20%; align-items: center"
                />
                <dl>
                  <dt>
                    중요 개인정보에 대한 접근기록은 <br />위.변조 및 훼손을
                    방지하도록 저장
                  </dt>
                  <dd>암호화하여 저장 <br />(암호화는 위.변조가 불가능)</dd>
                </dl>
              </li>
              <li>
                <v-img
                  src="@/assets/img/product/cubeone/cubeone_icon0-4.png"
                  alt=""
                  style="margin: 0 auto; max-width: 20%; align-items: center"
                />
                <dl>
                  <dt>접근통제 실시</dt>
                  <dd>
                    암호화한 칼럼에 대한 접근제어 및 통제 <br />(네트웍 보안
                    장치와 더불어 요건 충족)
                  </dd>
                </dl>
              </li>
              <li>
                <v-img
                  src="@/assets/img/product/cubeone/cubeone_icon0-5.png"
                  alt=""
                  style="margin: 0 auto; max-width: 20%; align-items: center"
                />
                <dl>
                  <dt>
                    비밀번호 및 바이오정보는 <br />일방향으로 암호화하여 저장
                  </dt>
                  <dd>SHA-1/256/384/512 알고리즘 적용</dd>
                </dl>
              </li>
            </ul> -->
          </section>
        </section>
        <!-- cubeone0 -->

        <section id="plugin" class="inner_box cocon">
          <h3 class="con_tit">
            <!-- <v-img src="@/assets/img/product/cubeone/cubeone_tit1.png" alt="" />Plug-in -->
            Plug-in
          </h3>
          <div class="imgArea">
            <v-img
              src="@/assets/img/product/cubeone/cubeone_img1.jpg"
              alt=""
              style="margin: 0 auto; max-width: 55%; align-items: center"
            />
          </div>
          <ol class="clearfix">
            <li>
              <span class="num">01</span>
              <dl>
                <dt>Application 독립성</dt>
                <dd>
                  App에서 사용하는 SQL의 수정을 <br />최소한으로 하여 적용 가능
                </dd>
              </dl>
            </li>
            <li>
              <span class="num">02</span>
              <dl>
                <dt>무중단 구축</dt>
                <dd>
                  초기 암호화 적용 및 암호화 컬럼 추가 시 <br />무중단 암호화
                  적용(Oracle Version)
                </dd>
              </dl>
            </li>
            <li>
              <span class="num">03</span>
              <dl>
                <dt>암호화 색인 검색</dt>
                <dd>
                  암호화 되어 저장된 Index 검색기능<br class="br" />암호화 적용
                  후 Application 성능 보장
                </dd>
              </dl>
            </li>
            <li>
              <span class="num">04</span>
              <dl>
                <dt>빠른 암호화 성능</dt>
                <dd>
                  암/복호화 시 시스템 부하를 최소화<br />하는 구조 (타 제품 대비
                  2~3배 성능)
                </dd>
              </dl>
            </li>
          </ol>
        </section>
        <!-- #plugin -->

        <section id="api" class="inner_box cocon">
          <h3 class="con_tit">
            <!-- <v-img src="@/assets/img/product/cubeone/cubeone_tit2.png" alt="" />API -->
            API
          </h3>
          <div class="imgArea">
            <v-img
              src="@/assets/img/product/cubeone/cubeone_img2.jpg"
              alt=""
              style="margin: 0 auto; max-width: 55%; align-items: center"
            />
          </div>
          <ol class="clearfix">
            <li>
              <span class="num">01</span>
              <dl>
                <dt>DBMS간의 암호화 기능 제공</dt>
                <dd>
                  DBMS에 종속적이지 않는 이기종 <br />DBMS간의 암호화 기능 제공
                </dd>
              </dl>
            </li>
            <li>
              <span class="num">02</span>
              <dl>
                <dt>Daemon-less 서비스 구조</dt>
                <dd>
                  간단한 Daemon-less 서비스 <br />구조로서 무장애 구조 및 고성능
                  <br />(경쟁제품 대비 약 50% 이상 빠름)
                </dd>
              </dl>
            </li>
            <li>
              <span class="num">03</span>
              <dl>
                <dt>Local 배치 업무 시 총 수행시간 단축</dt>
                <dd>
                  DBMS서버에 Hybrid(Plug-In &amp; API) 방식<br class="br" />적용
                  시 Local 배치 업무 시 총 수행시간 단축
                </dd>
              </dl>
            </li>
            <li>
              <span class="num">04</span>
              <dl>
                <dt>API Handler 별도 제공 (Option)</dt>
                <dd>
                  암호화 필드 색인검색 / 비정형 SQL의 처리 / <br />초기 무중단
                  암호화 구축을 위하여 <br />API Handler 별도 제공 (Option)
                </dd>
              </dl>
            </li>
          </ol>
        </section>
        <!-- #api -->

        <section id="file" class="inner_box cocon">
          <h3 class="con_tit">
            <!-- <v-img src="@/assets/img/product/cubeone/cubeone_tit3.png" alt="" />FILE -->
            FILE
          </h3>
          <div class="imgArea">
            <v-img
              src="@/assets/img/product/cubeone/cubeone_img3.jpg"
              alt=""
              style="margin: 0 auto; max-width: 80%; align-items: center"
            />
            <ul>
              <li>
                <span>01</span>사용자 프로그램에 의하여 JPG(201608.jpg) 파일
                생성
              </li>
              <li>
                <span>02</span>CubeOne Agent로 설정된
                <em>신규 파일 생성 감시</em>
              </li>
              <li><span>03</span>암호화 된 파일 생성 (201608.enc)</li>
              <li><span>04</span>암호화 적용 된 이전 소스 파일 제거</li>
            </ul>
          </div>
          <ol class="clearfix">
            <li>
              <span class="num">01</span>
              <dl>
                <dt>실시간 생성 파일에 암호화 기능 지원</dt>
                <dd>일반파일과 종적되는 파일 <br />모두 지원 가능</dd>
              </dl>
            </li>
            <li>
              <span class="num">02</span>
              <dl>
                <dt>App 수정없이 암호화 적용</dt>
                <dd>App 수정없이 자동화 된 <br />백그라운드로 암호화 작업</dd>
              </dl>
            </li>
            <li>
              <span class="num">03</span>
              <dl>
                <dt>낮은 CPU 사용률</dt>
                <dd>CPU 사용율이 낮으며, <br />암호화 부하는 1~2%</dd>
              </dl>
            </li>
            <li>
              <span class="num">04</span>
              <dl>
                <dt>국정원 인증 기준 충족</dt>
                <dd>
                  표준 CubeOne API를 기반으로 함으로써, <br />현행관련기관의
                  보안요건을 모두 준수
                </dd>
              </dl>
            </li>
          </ol>
        </section>
        <!-- #file -->

        <section id="salt" class="inner_box cocon">
          <h3 class="con_tit">
            <!-- <v-img src="@/assets/img/product/cubeone/cubeone_tit4.png" alt="" />SALT -->
            SALT
          </h3>
          <div class="imgArea">
            <v-img
              src="@/assets/img/product/cubeone/cubeone_img4.jpg"
              alt=""
              class="pc"
            />
            <v-img
              src="@/assets/img/product/cubeone/cubeone_img4_m.jpg"
              alt=""
              class="mobile"
            />
          </div>
          <ol class="clearfix">
            <li>
              <span class="num">01</span>
              <dl>
                <dt>Random SALT 지원</dt>
                <dd>
                  동일한 비번이 다수 존재할 지라도 <br />모두 다른 값으로 SHA256
                  변환
                </dd>
              </dl>
            </li>
            <li>
              <span class="num">02</span>
              <dl>
                <dt>비밀번호 처리/ 저장 상태</dt>
                <dd>
                  생성 되는 SALT는 누구도 <br />알 수 없어 보안성인 극대화
                </dd>
              </dl>
            </li>
            <li>
              <span class="num">03</span>
              <dl>
                <dt>전송 구간 암호화 지원</dt>
                <dd>
                  Client 프로그램 ↔ 서버 어플리케이션<br />간의 전문 전송시에도
                  AES <br />암호화 하여 전달
                </dd>
              </dl>
            </li>
            <li>
              <span class="num">04</span>
              <dl>
                <dt>간편한 Migration</dt>
                <dd>
                  기존의 SHA256으로만 암호화된 <br />비밀번호를 DB에서 읽어,
                  <br />Random SALT 적용된 <br />SHA256 data로 일괄 변환
                </dd>
              </dl>
            </li>
          </ol>
        </section>
        <!-- #salt -->
      </div>
    </main>
  </div>
</template>
<script>
export default {};
</script>
<style lang=""></style>
